import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Staff } from '../pages/';
import StaffData from '../pages/staff/StaffData';
import { NewPasswordPage } from '../components/authorization/NewPasswordPage';
import StaffCamps from '../sections/staff/StaffCamps';
import StaffSettlements from '../sections/staff/StaffSettlements';
import StaffWorkStandards from '../sections/staff/StaffWorkStandards';
import StaffPersonalDocuments from '../sections/staff/StaffPersonalDocuments';
import StaffEssentialDocuments from '../sections/staff/StaffEssentialDocuments';
import StaffAdditionalDocuments from '../sections/staff/StaffAdditionalDocuments';
import QuestionnaireFormPage from '../pages/employee/QuestionnaireFormPage';
import DocumentSigningPage from '../pages/guest/DocumentSigningPage';
import StaffPersonalDataProtectionDocuments from '../sections/staff/StaffPersonalDataProtectionDocuments';
import StaffOrganizingCampsInstructionDocuments from '../sections/staff/StaffOrganizingCampsInstructionDocuments';

export default () => (
  <Routes>
    <Route path="*" element={<Navigate to="/staff" />} />

    <Route path="/staff" element={<Staff />}>
      <Route path="" element={<StaffData />}/>
      <Route path="camps" element={<StaffCamps />}/>
      <Route path="settlements" element={<StaffSettlements />}/>
      <Route path="personal-documents" element={<StaffPersonalDocuments />}/>
      <Route path="work-standards" element={<StaffWorkStandards />}/>
      <Route path="personal-data-protection-documents" element={<StaffPersonalDataProtectionDocuments />} />
      <Route path="organizing-camps-instruction-documents" element={<StaffOrganizingCampsInstructionDocuments />} />
      <Route path="essential-documents" element={<StaffEssentialDocuments />}/>
      <Route path="additional-documents" element={<StaffAdditionalDocuments />}/>
    </Route>
    <Route path="/restore-password/new-password/:uidb64/:token" element={<NewPasswordPage temporaryPasswordReset={true} />} exact />
    <Route path=":id/kwestionariusz" element={<QuestionnaireFormPage />}/>
    <Route path=":id/sign_document/:annex_nr/:model" element={<DocumentSigningPage />}/>
    <Route path=":id/sign_document/:annex_nr/:model/:module_identifier" element={<DocumentSigningPage />}/>
  </Routes>
);
